import {
  Box,
  Button,
  Divider,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import React from "react";
import { useHistory } from "react-router";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import apiHelper from "../../../util/ApiHelper";

const useStyles = makeStyles((theme) => ({
  innerBox: {
    background: "#ffffff",
    marginBottom: theme.spacing(4),
    "& *": {
      fontSize: "13px",
      lineHeight: "15px",
    },
  },
  sectionBox: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  sectionTitle: {
    fontWeight: "300",
    fontSize: "13px",
    lineHeight: "15px",
    color: "#333333",
  },
  itemTitle: {
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#333333",
  },
  itemValue: {
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#333333",
  },
  input: {
    width: "100%",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
  buttonGroup: {
    textAlign: "right",
    marginTop: "-20px",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
}));

function CallForEntryDetailPage(props) {
  const history = useHistory();
  const classes = useStyles();
  const { match, disabled, location } = props;
  const { id } = match.params;
  const [defaultValue, setDefaultValue] = React.useState({});
  const page = (location.state && location.state.page) || 0;
  const rowsPerPage = (location.state && location.state.rowsPerPage) || 10;

  const { control, handleSubmit, reset } = useForm({
    defaultValues: React.useMemo(() => defaultValue, [defaultValue]),
  });

  const getApplicationDetail = React.useCallback(async () => {
    try {
      const result = await apiHelper.hkiff.getEntriesApplicationById(id);
      setDefaultValue(result.data);
      reset(result.data);
    } catch (err) {
      console.log(err);
    }
  }, [id, reset]);

  const updateApplicationDetail = async (data) => {
    try {
      const result = await apiHelper.hkiff.updateEntriesApplicationById(
        id,
        data
      );
      if (result.data.id) {
        toast.dark("Your changes is saved.");
        // redirect with page & rowsPerPage data
        history.push({
          pathname: "/hkiff/call-for-entry",
          state: { page: page, rowsPerPage: rowsPerPage },
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (value) => {
    const data = {
      emailSent: value.submission.emailSent,
      flag: value.submission.flag,
      paymentMethod: value.paymentRecord[0].paymentMethod,
      paymentVerified: value.submission.paymentVerified,
      remarks: value.submission.remarks,
      reviewerComments: value.submission.reviewerComments,
      screenerVerified: value.submission.screenerVerified,
      submissionStatus: value.submission.submissionStatus,
    };
    console.log(data);
    updateApplicationDetail(data);
  };

  React.useEffect(() => {
    getApplicationDetail();
  }, [getApplicationDetail]);

  console.log(defaultValue);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Entry Management > Update Submission
      </Typography>
      <Box className={classes.innerBox}>
        <Box className={classes.sectionBox}>
          <Grid container xs={12} direction="row">
            <Grid item xs={6}>
              <strong>Reference no. #{defaultValue.referenceNum}</strong>
            </Grid>
            <Grid item xs={6}>
              <Box
                width="100%"
                component="span"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <strong>Last Update Time &nbsp; </strong>{" "}
                {defaultValue.updateTime}
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* ENTRY Detail */}
        <Box className={classes.sectionBox}>
          <Grid container xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Entry Details
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Original Title
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.originalTitle}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>Title</Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.englishTitle}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Original Language
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.originalLanguage}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Subtitle
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.subtitle &&
                      defaultValue.subtitle.toString() === "1"
                        ? "English Subtitled"
                        : "English Dubbed"}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Director
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.director}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Year Of Production
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.yearOfProduction}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Origin Country
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.originCountry}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Duration
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.duration}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Screen Format
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.screenFormat}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Screen Ratio
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.screenRatio}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>Color</Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.color}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* SCREENER DETAILS */}
        <Box className={classes.sectionBox}>
          <Grid container xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Screener Details
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item xs={12} direction="row" spacing={3}>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Screener Copy
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue?.screenerType?.toString() === "1" && "DVD"}
                      {defaultValue?.screenerType?.toString() === "2" &&
                        "Vimeo"}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>Link</Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.screenerUrl}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item direction="column" spacing={1} xs={4}>
                  <Grid item>
                    <Typography className={classes.itemTitle}>
                      Password
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.itemValue}>
                      {defaultValue.screenerPwd}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container item xs={12} direction="row" spacing={1}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Synopsis
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.synopsis}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item xs={12} direction="row" spacing={1}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Director Biography
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.directorBiography}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* CONTACT DETAILS */}
        <Box className={classes.sectionBox}>
          <Grid container item xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Contact Details
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Contact Name
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.contactName}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Contact Address
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.contactAddress}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Contact Phone
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.contactPhone}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Contact Fax
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.contactFax}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Contact Email
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.contactEmail}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {/* PAYMENT DETAILS */}
        <Box className={classes.sectionBox}>
          <Grid container item xs={12} direction="row" spacing={3}>
            <Grid container item xs={12} direction="row">
              <Typography className={classes.sectionTitle}>
                Payment Details
              </Typography>
            </Grid>
            <Grid container item xs={12} direction="row" spacing={3}>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Payment Method
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.paymentRecord &&
                      defaultValue.paymentRecord[0] &&
                      defaultValue.paymentRecord[0].paymentMethod ===
                        "transfer" &&
                      "TT"}
                    {defaultValue.paymentRecord &&
                      defaultValue.paymentRecord[0] &&
                      defaultValue.paymentRecord[0].paymentMethod === "money" &&
                      "bank draft"}
                    {defaultValue.paymentRecord &&
                      defaultValue.paymentRecord[0] &&
                      defaultValue.paymentRecord[0].paymentMethod ===
                        "online" &&
                      "cityline"}
                    {defaultValue.paymentRecord &&
                      defaultValue.paymentRecord[0] &&
                      defaultValue.paymentRecord[0].paymentMethod ===
                        "waived" &&
                      "waived"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item direction="column" spacing={1} xs={4}>
                <Grid item>
                  <Typography className={classes.itemTitle}>
                    Payment Status
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.itemValue}>
                    {defaultValue.paymentRecord &&
                      defaultValue.paymentRecord[0] &&
                      defaultValue.paymentRecord[0].paymentStatus === 0 &&
                      "Pending"}
                    {defaultValue.paymentRecord &&
                      defaultValue.paymentRecord[0] &&
                      defaultValue.paymentRecord[0].paymentStatus === 1 &&
                      "Confirmed"}
                    {defaultValue.paymentRecord &&
                      defaultValue.paymentRecord[0] &&
                      defaultValue.paymentRecord[0].paymentStatus === 2 &&
                      "Failed"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <Box className={classes.innerBox}>
            <Box className={classes.sectionBox}>
              <Grid container xs={12} direction="row" spacing={3}>
                <Grid item xs={12}>
                  <strong>Fields for review team</strong>
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={3}>
                <Grid container item xs={12} direction="row" spacing={3}>
                  <Grid container item direction="column" spacing={1} xs={6}>
                    <Grid item>
                      <Typography className={classes.itemTitle}>
                        Screener Verified
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Controller
                        control={control}
                        defaultValue={
                          defaultValue?.submission?.screenerVerified
                        }
                        name="submission.screenerVerified"
                        render={({
                          field: { value, onChange, ...rest },
                          fieldState,
                        }) => (
                          <ToggleButtonGroup
                            {...rest}
                            value={value}
                            onChange={(event, newFormats) => {
                              onChange(newFormats);
                            }}
                            exclusive
                            aria-label="Screener verify status"
                            className={classes.input}
                          >
                            <ToggleButton value={0} aria-label="Pending">
                              Pending
                            </ToggleButton>
                            <ToggleButton value={1} aria-label="Confirmed">
                              Confirmed
                            </ToggleButton>
                          </ToggleButtonGroup>
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid container item direction="column" spacing={1} xs={6}>
                    <Grid item>
                      <Typography className={classes.itemTitle}>
                        Screener Verified
                      </Typography>
                    </Grid>
                    <Grid item>
                      {defaultValue?.submission?.screenerUpdateTime || "-"}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item xs={12} direction="row" spacing={3}>
                  <Grid container item direction="column" spacing={1} xs={6}>
                    <Grid item>
                      <Typography className={classes.itemTitle}>
                        Payment Method
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Controller
                        control={control}
                        defaultValue={
                          defaultValue?.paymentRecord &&
                          defaultValue.paymentRecord[0] &&
                          defaultValue.paymentRecord[0].paymentMethod
                        }
                        name="paymentRecord[0].paymentMethod"
                        render={({
                          field: { value, onChange, ...rest },
                          fieldState,
                        }) => (
                          <ToggleButtonGroup
                            {...rest}
                            value={value}
                            onChange={(event, newFormats) => {
                              onChange(newFormats);
                            }}
                            exclusive
                            aria-label="Screener verify status"
                            className={classes.input}
                          >
                            <ToggleButton value="transfer" aria-label="TT">
                              TT
                            </ToggleButton>
                            <ToggleButton value="money" aria-label="bank draft">
                              bank draft
                            </ToggleButton>
                            <ToggleButton value="online" aria-label="cityline">
                              cityline
                            </ToggleButton>
                            <ToggleButton value="waived" aria-label="waived">
                              waived
                            </ToggleButton>
                          </ToggleButtonGroup>
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item xs={12} direction="row" spacing={3}>
                  <Grid container item direction="column" spacing={1} xs={6}>
                    <Grid item>
                      <Typography className={classes.itemTitle}>
                        Payment Verified
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Controller
                        control={control}
                        defaultValue={defaultValue?.submission?.paymentVerified}
                        name="submission.paymentVerified"
                        render={({
                          field: { value, onChange, ...rest },
                          fieldState,
                        }) => (
                          <ToggleButtonGroup
                            {...rest}
                            value={value}
                            onChange={(event, newFormats) => {
                              onChange(newFormats);
                            }}
                            exclusive
                            aria-label="Screener verify status"
                            className={classes.input}
                          >
                            <ToggleButton value={0} aria-label="Pending">
                              Pending
                            </ToggleButton>
                            <ToggleButton value={1} aria-label="Confirmed">
                              Confirmed
                            </ToggleButton>
                          </ToggleButtonGroup>
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid container item direction="column" spacing={1} xs={6}>
                    <Grid item>
                      <Typography className={classes.itemTitle}>
                        Payment Status Update Time
                      </Typography>
                    </Grid>
                    <Grid item>
                      {defaultValue?.submission?.paymentUpdateTime || "-"}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item xs={12} direction="row" spacing={3}>
                  <Grid container item direction="column" spacing={1} xs={6}>
                    <Grid item>
                      <Typography className={classes.itemTitle}>
                        Submission Status
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Controller
                        control={control}
                        defaultValue={
                          defaultValue?.submission?.submissionStatus
                        }
                        name="submission.submissionStatus"
                        render={({
                          field: { value, onChange, ...rest },
                          fieldState,
                        }) => (
                          <ToggleButtonGroup
                            {...rest}
                            value={value}
                            onChange={(event, newFormats) => {
                              onChange(newFormats);
                            }}
                            exclusive
                            aria-label="Screener verify status"
                            className={classes.input}
                          >
                            <ToggleButton value={0} aria-label="Submitted">
                              Submitted
                            </ToggleButton>
                            <ToggleButton value={1} aria-label="Incomplete">
                              Incomplete
                            </ToggleButton>
                            <ToggleButton
                              value={2}
                              aria-label="In Consideration"
                            >
                              In Consideration
                            </ToggleButton>
                          </ToggleButtonGroup>
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid item>
                      <Typography className={classes.itemTitle}>
                        Submission Status Update Time
                      </Typography>
                    </Grid>
                    <Grid item>
                      {defaultValue?.submission?.statusUpdateTime || "-"}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item xs={12} direction="row">
                  <Grid item xs={12}>
                    <Typography className={classes.itemTitle}>
                      Reviewer Comments
                    </Typography>
                  </Grid>
                  <Grid container item xs={12}>
                    <Controller
                      control={control}
                      defaultValue={defaultValue?.submission?.reviewerComments}
                      name="submission.reviewerComments"
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          multiline
                          rows={5}
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} direction="row">
                  <Grid item xs={12}>
                    <Typography className={classes.itemTitle}>
                      Remarks
                    </Typography>
                  </Grid>
                  <Grid container item xs={12}>
                    <Controller
                      control={control}
                      defaultValue={defaultValue?.submission?.remarks}
                      name="submission.remarks"
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          multiline
                          rows={5}
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12} direction="row">
                  <Grid container item direction="column" spacing={1} xs={6}>
                    <Grid item>
                      <Typography className={classes.itemTitle}>
                        Flag
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Controller
                        control={control}
                        defaultValue={defaultValue?.submission?.flag}
                        name="submission.flag"
                        render={({
                          field: { value, onChange, ...rest },
                          fieldState: { error },
                        }) => (
                          <ToggleButtonGroup
                            {...rest}
                            value={value}
                            onChange={(event, newFormats) => {
                              onChange(newFormats);
                            }}
                            exclusive
                            aria-label="Flag"
                            className={classes.input}
                          >
                            <ToggleButton value="black" aria-label="Black">
                              Black
                            </ToggleButton>
                            <ToggleButton value="blue" aria-label="Blue">
                              Blue
                            </ToggleButton>
                            <ToggleButton value="yellow" aria-label="Yellow">
                              Yellow
                            </ToggleButton>
                          </ToggleButtonGroup>
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
          {disabled || (
            <div className={classes.buttonGroup}>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                Update Submission
              </Button>
            </div>
          )}
        </fieldset>
      </form>
    </Box>
  );
}

export default CallForEntryDetailPage;
